define.alias("shared/models/linkedin-post", "preview-grid/models/linkedin-post");